/**
 * Enum for predefined contact form reasons
 */
export enum ContactReason {
  BRIEFING = 'Request a vendor briefing or meeting',
  ROADMAP = 'Ask about product roadmap, strategy, or updates',
  REFERENCES = 'Request customer references, case studies, or data',
  COLLABORATION = 'Explore collaboration on research or events',
  FEEDBACK = 'Share observations or feedback from the market',
  CLARIFICATION = 'Clarify positioning, competitive, or pricing information',
  CONCERN = 'Report content inaccuracy or other concern',
  OTHER = 'Other (please specify)',
}

/**
 * Contact form submission data from frontend
 * Note: userName and userEmail are extracted from the authenticated user on the backend
 */
export interface ContactFormSubmissionDTO {
  reason: ContactReason;
  topic: string;
  additionalComments: string;
}

/**
 * Contact form response after successful submission
 */
export interface ContactFormResponseDTO {
  success: boolean;
  message: string;
}
